import { redirectToSouscription } from "../helpers/souscription";
import { useZeroFranchiseTracking } from "../hooks/useZeroFranchiseTracking";
import { Button } from "./Button";
import { ArrowRightIcon } from "./icons/ArrowRightIcon";
import { TrustpilotMicroScoreWidget } from "./TrustpilotMicroScoreWidget";

const HERO_IMAGE = "/assets/pack-zero-franchise/hero-driver.png";
const HERO_IMAGE_ALT = "Conducteur souriant à côté de sa voiture";
const IMAGE_GRADIENT = "linear-gradient(143deg, rgba(0,0,0,0.2) 6%, rgba(102,102,102,0) 39%)";

export const HeroSection = () => {
  const { trackOnlineSubscription } = useZeroFranchiseTracking();

  const handleSubscribe = () => {
    trackOnlineSubscription("intro_pack");
    redirectToSouscription();
  };

  return (
    <section className="mx-auto max-w-[1600px]">
      <div className="relative bg-white xl:hidden">
        <div
          aria-hidden
          className={[
            "absolute inset-x-0 top-0 z-0 bg-[#FFD100]",
            "h-[598px] rounded-b-[24px]",
            "md:inset-x-10 md:h-[694px] md:rounded-[32px]",
          ].join(" ")}
        />

        <div className="relative z-10 flex flex-col gap-6 px-4 py-14 md:px-[96px]">
          <div className="flex flex-col gap-2 text-[#0D0D0D]">
            <h1 className="font-maison-extended-bold font-bold text-[33px] leading-[1.2] md:text-[44px]">
              Dites adieu à la franchise avec Roole
            </h1>
            <p className="text-[16px] leading-[1.6] md:text-[19px]">
              Roole intervient en complément de votre assureur principal pour rembourser votre
              franchise.
            </p>
          </div>

          <div className="flex flex-col gap-10">
            <div className="flex flex-col gap-4 text-[#0D0D0D]">
              <div className="flex flex-col gap-1">
                <p className="text-[23px] font-bold leading-[1.2]">Pack Zéro Franchise</p>
                <div className="flex items-center gap-2">
                  <p className="text-[44px] font-maison-extended-bold font-bold leading-[1.2]">
                    13
                  </p>
                  <div className="flex flex-col">
                    <p className="text-[16px] font-bold leading-[1.2]">€/mois</p>
                    <p className="text-[13px] leading-[1.6] tracking-[0.26px]">sans engagement</p>
                  </div>
                </div>
              </div>

              <Button
                variant="primary-dark"
                trailingIcon={<ArrowRightIcon size={20} />}
                className="w-fit"
                onClick={handleSubscribe}
              >
                Souscrire en ligne
              </Button>
            </div>

            <div className="relative aspect-[1802/1323] w-full overflow-hidden rounded-[24px]">
              <img
                src={HERO_IMAGE}
                alt={HERO_IMAGE_ALT}
                className="block h-full w-full object-cover"
              />
              <div
                aria-hidden
                className="pointer-events-none absolute inset-0"
                style={{ backgroundImage: IMAGE_GRADIENT }}
              />
            </div>
          </div>

          <TrustpilotMicroScoreWidget trackingSection="widget_un" />
        </div>
      </div>

      <div className="hidden px-8 py-20 xl:block">
        <div className="rounded-[40px] bg-[#FFD100] px-20 pt-16 pb-16">
          <div className="flex flex-row gap-16">
            <div className="flex shrink-0 flex-col gap-10 xl:w-[464px] 2xl:min-w-[630px]">
              <div className="flex flex-col gap-8">
                <div className="flex flex-col gap-4 text-[#0D0D0D]">
                  <h1 className="font-maison-extended-bold font-bold text-[44px] leading-[1.2]">
                    Dites adieu à la franchise avec Roole
                  </h1>
                  <p className="text-[19px] leading-[1.6]">
                    Roole intervient en complément de votre assureur principal pour rembourser votre
                    franchise.
                  </p>
                </div>

                <div className="flex flex-col gap-6">
                  <div className="flex flex-col gap-1 text-[#0D0D0D]">
                    <p className="text-[28px] font-bold leading-[1.2]">Pack Zéro Franchise</p>
                    <div className="flex items-start gap-3">
                      <p className="text-[48px] font-maison-extended-bold font-bold leading-[1.2]">
                        13
                      </p>
                      <div className="flex flex-col pt-[6px]">
                        <p className="text-[19px] font-bold leading-[1.2]">€/mois</p>
                        <p className="text-[13px] leading-[1.6] tracking-[0.26px]">
                          sans engagement
                        </p>
                      </div>
                    </div>
                  </div>

                  <Button
                    variant="primary-dark"
                    trailingIcon={<ArrowRightIcon size={20} />}
                    className="w-fit"
                    onClick={handleSubscribe}
                  >
                    Souscrire en ligne
                  </Button>
                </div>
              </div>

              <TrustpilotMicroScoreWidget trackingSection="widget_un" />
            </div>

            <div className="relative min-w-0 flex-1">
              <div className="absolute inset-x-0 -inset-y-[84px] overflow-hidden rounded-[40px]">
                <img
                  src={HERO_IMAGE}
                  alt={HERO_IMAGE_ALT}
                  className="h-full w-full object-cover object-left"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
